import { render, staticRenderFns } from "./TextCheckbox.vue?vue&type=template&id=2fcc3216&scoped=true&"
import script from "./TextCheckbox.vue?vue&type=script&lang=js&"
export * from "./TextCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TextCheckbox.vue?vue&type=style&index=0&id=2fcc3216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc3216",
  null
  
)

export default component.exports